export default "__VITE_ASSET__DMU4yh7E__"